import { UserRole, UserRoles } from '../types/userRoles'

export const allAuthorities: UserRole[] = [UserRoles.MEMBER, UserRoles.ADMIN]

export const isAuthorized = (role: UserRole) => {
  return allAuthorities.includes(role)
}

export const isMember = (role: UserRole) => {
  return role === UserRoles.MEMBER
}

export const isAdmin = (role: UserRole) => {
  return role === UserRoles.ADMIN
}
